// src/hooks/useAnalyticsEvent.ts
import { getAnalytics, logEvent } from 'firebase/analytics';
import ReactGA from 'react-ga4';
import { shouldCollectAnalytics } from '../utils/analytics-collection.util';

export function useAnalyticsEvent() {
  return (eventName: string, params?: Record<string, any>) => {
    if (!shouldCollectAnalytics()) {
      return;
    }

    try {
      const analytics = getAnalytics();
      logEvent(analytics, eventName, params);
    } catch (e) {
      // Optionally handle analytics errors
      console.error('Analytics event logging failed:', e);
    }
    try {
      ReactGA.event(eventName, params);
    } catch (e) {
      console.error('GA4 event logging failed:', e);
    }
  };
}